import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { Currencies } from '../../core/pipe/currency.pipe';
import { MeterMediaType } from './const/enums';
import { PriceListItem } from './priceListItem';

export class PriceList extends ModelBase {
  constructor() {
    super();
  }

  articleId: string;
  articleCodeCaption: string;
  meterTypeCaption: string;
  meterType: MeterMediaType;
  name: string;
  currencyCode: string;
  prices: PriceListItem[];
  latestPrice: Money;
  todayPrice: Money;
}
